/**
 * Extract currency symbol for fiat currency
 */
export function extractFiatSymbol({ fiatCode }: { fiatCode?: string }): string {
  if (!fiatCode) return '$'

  try {
    // Use Intl.NumberFormat to get the currency symbol
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: fiatCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })

    // Format 0 to get just the symbol
    const formatted = formatter.format(0)

    // Extract symbol by removing digits and spaces
    const symbol = formatted.replace(/[0-9\s]/g, '')

    return symbol || '$'
  } catch {
    // Fallback to manual mapping for common currencies
    const symbolMap: Record<string, string> = {
      USD: '$',
      EUR: '€',
      GBP: '£',
      JPY: '¥',
      CNY: '¥',
      KRW: '₩',
      RUB: '₽',
      BRL: 'R$',
      INR: '₹',
      AUD: 'A$',
      CAD: 'C$',
      CHF: 'CHF',
      // Add more as needed
    }

    return symbolMap[fiatCode] || '$'
  }
}
